import moment from 'moment';
import { useIntl } from 'react-intl';
import { subTopicSupport, SupportType, typesSupportOccorence, typeSubjectOccorence } from '../../../constants';
import { tasOccurrence } from '../../../types';
import { ContentLoader } from '@rio-cloud/rio-uikit';
import { convertMinutesToHours } from '../../../../../utils/dateUtils';
interface Props {
    subject?: string;
    supportType?: string;
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    timeInStatus?: string | number;
    statusUpdatedAt?: string;
    isLoading: boolean;
    subtopic?: string;
}

const Label = ({ children }: { children: string }) => {
    return (
        <span className="text-size-14 text-color-dark">{children}</span>
    )
};

const Value = ({ children }: { children?: string | number }) => {
    return (
        <span className="text-size-16 text-color-darker" style={{textAlign: 'right'}}>{children || '-'}</span>
    )
};

const CardInfo = ({ subject, supportType, createdBy, createdAt, updatedAt, timeInStatus, statusUpdatedAt, isLoading, subtopic }: Props) => {
    const intl = useIntl();
    const supportTypeLabelId = typesSupportOccorence[supportType as keyof typeof typesSupportOccorence];
    const style = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' };

    return (
        <div className="border padding-15 display-flex flex-column rounded height-100pct justify-content-between">
            <div>
                <span className="text-medium text-size-16">{intl.formatMessage({ id: 'intl-msg:support.cardInfo.title' })}</span>
            </div>
            <div className="width-100pct" style={style}>
                <Label>{intl.formatMessage({ id: 'intl-msg:tas.support.toolbar.supportType' })}</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{supportTypeLabelId ? intl.formatMessage({ id: supportTypeLabelId }) : undefined}</Value>
                )}
            </div>
{/*             
            <div className="width-100pct" style={style}>
                <Label>Assunto</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{typeSubjectOccorence[subject as keyof typeof typeSubjectOccorence]}</Value>
                )}
            </div>
            
            
            {subject !== SupportType.CONTRACT_CANCELLATION && subject !== SupportType.COMMERCIAL && supportType !== "TECHNICAL_SUPPORT" ? (
                <div className="width-100pct" style={style}>
                    <Label>Tema</Label>
                    {isLoading ? (
                        <ContentLoader className='max-width-100' />
                    ) : (
                        <Value>{subTopicSupport[subtopic as keyof typeof subTopicSupport]}</Value>
                    )}
                </div>
            ) : null} */}

            <div className="width-100pct" style={style}>
                <Label>{intl.formatMessage({ id: 'intl-msg:support.constants.field.createdBy' })}</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{createdBy}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>{intl.formatMessage({ id: 'intl-msg:support.constants.field.createdAt' })}</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{moment.utc(createdAt).local().format('DD/MM/YYYY HH:mm')}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>{intl.formatMessage({ id: 'intl-msg:support.constants.field.updatedAt' })}</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{moment.utc(updatedAt).local().format('DD/MM/YYYY HH:mm')}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>{intl.formatMessage({ id: 'intl-msg:tas.support.toolbar.sort.stepTime' })}</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{convertMinutesToHours(Number(timeInStatus))}</Value>
                )}
            </div>
        </div>
    )
};

export default CardInfo